import MdaeDropDownBox from "./component";
import { IMdaeDataUpdaterConfig } from "../../mdae-framework";
import { ISelectBoxOptions } from "devextreme-react/select-box";
export interface IMdaeSelectBoxProps extends ISelectBoxOptions {
  id: string;
  mdaeDropDownBoxTitle: any;
  mdaeDataUpdaterConfig?: Array<IMdaeDataUpdaterConfig>;
  required?: boolean;
  madeFieldTitleClassName?:string;
  ref?: React.ForwardedRef<any>;
}
export default MdaeDropDownBox;
